export default "__VITE_PUBLIC_ASSET__b08ad36b__"